import React from 'react';

import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';
import { productNameApi } from 'api';

export const PRODUCT_FILTER_OPTIONS = [
  {
    field: 'sku__icontains',
    label: 'SKU',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'product_sku',
    label: 'SKUs',
    type: FILTER_TYPES.MULTI_TEXT,
  },
  {
    field: 'name__icontains', // 상품 API 필터 쿼리
    label: 'Product Name',
    type: FILTER_TYPES.SEARCH,
    apiService: productNameApi, // 검색 API
    searchField: 'search__icontains', // 검색 API 쿼리
    renderItem: item => <div className="font-medium">{item.name}</div>,
  },
  {
    field: 'brand__name__icontains',
    label: 'Brand Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'is_active',
    label: 'Enable',
    type: FILTER_TYPES.SELECT,
    options: [
      { value: '', label: 'All' },
      { value: 'true', label: 'Active' },
      { value: 'false', label: 'Inactive' },
    ],
  },
  { ...PAGE_SIZE_FILTER },
];

export const CHANNEL_PRODUCT_FILTER_OPTIONS = [
  {
    field: 'channel__channel_type__icontains',
    label: 'Channel Type',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'channel_product_sku__icontains',
    label: 'Channel Product SKU',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'channel_product_sku',
    label: 'Channel Product SKUs',
    type: FILTER_TYPES.MULTI_TEXT,
  },
  {
    field: 'product__sku__icontains',
    label: 'Product SKU',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'product_sku',
    label: 'Product SKUs',
    type: FILTER_TYPES.MULTI_TEXT,
  },
  {
    field: 'is_product_linked',
    label: 'Product Linked Status',
    type: FILTER_TYPES.SELECT,
    options: [
      { value: 'true', label: 'Linked' },
      { value: 'false', label: 'UnLinked' },
    ],
  },
  { ...PAGE_SIZE_FILTER },
];
